import { Realtime as _Realtime } from 'ably';
import { getDefaultClientOptions } from '../getDefaultClientOptions';
function enforceDefaultClientOptions(AblyRealtime) {
  return class Realtime extends AblyRealtime {
    constructor(providedOptions) {
      const defaultClientOptions = getDefaultClientOptions();
      const clientOptions = Object.assign({}, defaultClientOptions, providedOptions);
      super(clientOptions);
    }
  };
}
export const AblyRealtime = enforceDefaultClientOptions(_Realtime);

// Compile-time assertions:
// 1) The wrapped class instance is still a subtype of native ably@3 Realtime.
// 2) Native ably@3 Realtime remains assignable to IRealtimeClient.
// Uses const assignments so failures produce readable error messages.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _v3WrapperSubtypeAssert = true;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _v3ClientSubtypeAssert = true;